const fr = { 
    serviceCall: 'Le fournisseur de services peut appeler',
    heading_request:        'Quels sont les détails de votre demande d\'emploi ?',
    valid_question1: 'D\'autres détails que vous jugez pertinents ?',
    valid_question2:        'Si vous ne fournissez pas suffisamment d\'informations. cela affectera le nombre de devis que vous recevrez.',
    valid_question3: 'Vous devez saisir au moins 100 lettres.',
    image_question: 'Souhaitez-vous ajouter des images ?',
    where_location: 'Où ? (Lieu du travail)',
    location_validation:        'Nous ne pouvons pas utiliser votre emplacement. Veuillez rechercher la ville ou saisir manuellement',
    userMyLocation: 'UTILISE MA LOCATION',
    enterCity: 'Entrez le nom de votre ville',
    when_job: 'Lorsque ? (date du travail)',
    answer_question: 'Souhaitez-vous répondre à ces questions ?',
    inputAnswer: 'Entrez votre réponse ici...',
    enterPhone: 'Entrez votre téléphone',
    phoneDescription:        'Nos pros con vous contactent plus rapidement si vous sélectionnez "Le fournisseur de services peut appeler".',
    enterPhoneNumber: 'Entrez votre numéro de téléphone',
    sendRequest: 'ENVOYER UNE DEMANDE',
    alert_image: 'Veuillez télécharger au moins une image.',
    alert_description: 'Veuillez saisir une description.',
    alert_address: 'Veuillez entrer votre adresse.',
    alert_one_option: 'Veuillez sélectionner une option.',
    alert_pick_date: 'Veuillez prendre la date.',
    alert_answer: 'Veuillez répondre à la question',
    alert_phone: 'Veuillez entrer le numéro de téléphone.',
    request_success_msg:         'Félicitations ! Vous avez demandé avec succès !',
    alert_close_description:        'Vous pouvez obtenir des devis gratuits en répondant à quelques questions supplémentaires.',
    go_on: 'CONTINUE',
    quit: 'QUITTER',
    servicesCompanyReady: "Société de services prête",
    allow_contacts: "Afficher mon numéro de téléphone",
    dont_disturbme: "Ne me dérange pas",
    only_phone: "Me contacter uniquement par téléphone",
    only_offers: "Envoyez-moi uniquement des offres",
    only_whatsapp: "Contactez-moi uniquement par WhatsApp",
  

    kEmailNullError: "Veuillez saisir votre e-mail",
    kInvalidEmailError: "Veuillez saisir une adresse e-mail valide",
    kPassNullError: "S'il vous plait entrez votre mot de passe",
    kConfirmPasswordError: "Mot de passe incompatible",
    kShortPassError:        "Le mot de passe est trop court, au moins 8 caractères",
    kMatchPassError: "Les mots de passe ne correspondent pas",
    kNameNullError: "S'il vous plait entrez votre nom entier",
    kPhoneNumberNullError:        "Veuillez entrer votre numéro de téléphone",


    email: 'E-mail',
    password: 'Mot de passe',
    pleaseendteryouremail: 'Veuillez saisir votre e-mail',
    pleaseenteryourpassword:        's\'il vous plait entrez votre mot de passe',

    confirmpassword: 'Confirmez le mot de passe',

    name: 'Nom',

    Congratulation: 'Félicitation',
    requestPriority: 'Priorité de la demande',


    free: 'Libérer',
    high: "haut",

    noSearchResult: 'Aucun résultat de recherche',
    inputThree: 'Veuillez saisir au moins 3 lettres',

    selected_city: 'Ville(s) sélectionnée(s)',
    specificTime: 'Moment précis (dans les trois semaines)',
    inTwoMonth: 'Dans deux mois',
    inSixMonth: 'Dans six mois',
    onlyPrice: 'Je cherche juste le prix',
    flexibleTime: 'Flexible',

    asap: 'Dès que possible',

    lab_continue: 'Continuer',


 //CUSTOM
 mainheading: 'Quel type de prestations recherchez-vous ?',
 back: 'Dos',
 serviceErrHead: 'Prestation vide',
 serviceError: 'Veuillez sélectionner un service que vous recherchez pour continuer.',

 requiredField: "champs requis",
 requireDesc: 'Ce champ est obligatoire.'

}

export default fr;